import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { getTimeDifference } from 'utils/helpers'
import { useViewport } from 'utils'

// components
import MerchShopCard from 'components/Card/MerchShopCard'

// apis
import StoreAPI from 'apis/store'

// styles
import styles from './index.module.scss'

const NFTMerchSection = props => {
  const { username, userId, label } = props
  const router = useRouter()
  const viewport = useViewport()
  const [merchList, setMerchList] = useState([])

  useEffect(() => {
    if (userId === undefined || userId === null) return

    StoreAPI.getStoreByUserId(userId, 1, 'all').then(
      res => {
        let list = []
        let items = res['items']
        items.map(item => {
          if (
            item.deleted_at === null &&
            (item.sale_end_at === null || getTimeDifference(item.sale_end_at) > 0) &&
            (item.supply === null || item.supply - item.current_supply > 0)
          ) {
            if (item.master_edition_address === null) {
              list.push(item)
            } else {
              if (
                item.master_edition_address?.length > 0 &&
                (item.listed_master_edition.endTime === null ||
                  getTimeDifference(item.listed_master_edition.endTime) > 0)
              ) {
                list.push(item)
              }
            }
          }
        })
        setMerchList(list)
      },
      error => {}
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  return (
    merchList.length > 0 && (
      <div className="w-full g-container mb-[45px]">
        <div className="w-full flex justify-between items-center">
          <div className={styles.caption}>{label}</div>
          {merchList.length > 5 && (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') && (
            <div
              className={styles.seeMore}
              onClick={() => {
                router.push(`/${username.replaceAll(' ', '%20')}/merch`)
              }}
            >
              {'See More'}
            </div>
          )}
        </div>
        <div className="w-full mt-[30px]">
          {merchList.slice(0, 5).length > 0 && (
            <div className="grid grid-cols-10 sm:grid-cols-20 gap-[9px] sm:gap-[20px] sm:gap-[20px] xl:gap-[30px]">
              {merchList.slice(0, 5).map((item, index) => (
                <div className="col-span-5 sm:col-span-10 lg:col-span-4" key={item.id}>
                  <MerchShopCard username={username} data={item} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  )
}

export default NFTMerchSection
